import { render, staticRenderFns } from "./OrganizationStructure.vue?vue&type=template&id=45070166&scoped=true"
import script from "./OrganizationStructure.vue?vue&type=script&lang=js"
export * from "./OrganizationStructure.vue?vue&type=script&lang=js"
import style0 from "./OrganizationStructure.vue?vue&type=style&index=0&id=45070166&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45070166",
  null
  
)

export default component.exports